export class Algorithm {
    ProgressStep() {
        // todo: Implement
    }
    constructor(cancelToken) {
        this.cancelToken = cancelToken;
    }
}
//# sourceMappingURL=algorithm.js.map